import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "switch";
var classes = {
    CONTAINER: 'tyl-switch-container',
    ROOT: 'tyl-switch',
    THUMB: 'tyl-switch__thumb',
    THUMB_UNDERLAY: 'tyl-switch__thumb-underlay',
    TRACK: 'tyl-switch__track',
    RIPPLE: 'tyl-switch__ripple',
    CHECKED: 'tyl-switch--checked',
    DISABLED: 'tyl-switch--disabled',
    DENSE: 'tyl-switch--dense',
    UPGRADED: 'tyl-switch--upgraded',
    FOCUSED: 'tyl-switch--focused'
};
var selectors = {
    INPUT: 'input',
    LABEL: 'label',
    THUMB: "." + classes.THUMB,
    TRACK: "." + classes.TRACK,
    ROOT: "." + classes.ROOT
};
var attributes = {
    DENSE: 'dense',
    CHECKED: 'checked',
    SLOT: 'slot',
    DISABLED: 'disabled',
};
var strings = {
    ARIA_CHECKED_ATTR: 'aria-checked',
    RIPPLE_SURFACE_SELECTOR: "." + classes.THUMB_UNDERLAY,
};
var CB_PROTO_PROPS = ['checked'];
export var SWITCH_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    strings: strings,
    CB_PROTO_PROPS: CB_PROTO_PROPS,
};
